import React from 'react'
import NextImage from 'next/image'
import { Type } from '@/components/common'
import useHydration from '@/services/hooks/useHydration'
import useWindowSize from '@/services/hooks/useWindowSize'
import { Image } from '../types'

export interface Props {
  image: Image
  className?: string
}

const BannerImage: React.FC<Props> = ({ image, className }) => {
  const {
    description,
    file: { url, details },
  } = image
  const { width, height } = details.image

  const { innerWidth } = useWindowSize()
  const crop = innerWidth > 0 && innerWidth < 1000
  const { isHydrated } = useHydration()

  if (!isHydrated) {
    return null
  }

  return (
    <div className={className}>
      <figure className="relative">
        <NextImage
          alt={description}
          className="mx-auto w-screen"
          loading="lazy"
          src={crop ? `https:${url}?w=1000&h=667&fit=thumb` : `https:${url}`}
          width={crop ? 1000 : width}
          height={crop ? 667 : height}
        />

        <Type
          as="figcaption"
          variant="caption-sm"
          className="mt-2 px-6 text-center text-core-gray-500"
        >
          {description}
        </Type>
      </figure>
    </div>
  )
}

export default BannerImage
